import '../../@types';

interface EventCallback {
    (...args: any[]): void;
    __EMIT_ONCE__?: boolean;
}

const events: { [name: string]: EventCallback[] } = {};
const emittedEvents: { [name: string]: any[] } = {};

/** 注册事件回调 */
export function onEvent(name: string, callback: EventCallback, onEmitted?: boolean) {
    delete callback.__EMIT_ONCE__;
    if (events[name]?.indexOf(callback) >= 0) return;
    if (!events[name]) events[name] = [];
    events[name].push(callback);
    if (onEmitted && emittedEvents[name] != null) setTimeout(() => callback(...emittedEvents[name]), 0);
}

/** 注册一次性的事件回调，该回调会在执行完毕后自动清理 */
export function onceEvent(name: string, callback: EventCallback) {
    callback.__EMIT_ONCE__ = true;
    if (events[name]?.indexOf(callback) >= 0) return;
    if (!events[name]) events[name] = [];
    events[name].push(callback);
}

/** 注册事件回调，同时该回调会监听并相应之前最后一次已经发生的事件 */
export function onEventEmitted(name: string, callback: EventCallback) {
    onEvent(name, callback, true);
}

/** 取消某个事件的回调 */
export function offEvent(name: string, callback: EventCallback) {
    const callbacks = events[name];
    if (!callbacks) return;
    const index = callbacks.indexOf(callback);
    if (index < 0) return;
    callbacks.splice(index, 1);
}

/** 触发事件回调 */
export function emitEvent(name: string, ...args: any[]) {
    const callbacks = events[name];
    if (callbacks?.length < 1) return;
    for (let i = 0; i <= callbacks.length; i++) {
        const cb = callbacks[i];
        if (!cb) continue;
        if (cb.__EMIT_ONCE__) {
            callbacks.splice(i, 1);
            i--;
        }
        setTimeout(() => cb(...args), 0);
    }
    emittedEvents[name] = args;
}
